import { first } from '@execonline-inc/collections';
import { emptyFragment, Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import useAvailabilitiesStore from '../../../../../Availabilities/AvailabilitiesStore/UseAvailabilitiesStore';
import ScheduledOrOnDemand from './ScheduledOrOnDemand';

function ProgramDates() {
  const { availabilities } = useAvailabilitiesStore();

  return first(availabilities)
    .map((availability) => {
      return (
        <Typography className="text-gray-900" variant="caption">
          <ScheduledOrOnDemand availability={availability} availabilities={availabilities} />
        </Typography>
      );
    })
    .getOrElse(emptyFragment);
}

export default observer(ProgramDates);
